import classNames from "classnames"

import JobDrawer, { JobDrawerTypes } from "./JobDrawer"

import ChevronIcon from "@components/elements/V2/Icons/ChevronIcon"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import { getTextColorClass } from "@utils/V2/color"
import { getDepartmentIcon } from "@utils/V2/department"
import React, { useState } from "react"

type Props = {
  job: HiBob.JobAd
  drawerData: JobDrawerTypes
}

const JobRow = ({ job, drawerData }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const DepartmentIcon = job.department
    ? getDepartmentIcon(job.department)
    : null

  return (
    <>
      <button
        className="group -mx-16 flex w-[calc(100%+32px)] flex-col items-start justify-between gap-16 border-b border-gray px-10 py-[18px] text-left transition-all duration-150 last:border-b-0 hover:rounded-12 hover:border-transparent hover:shadow-md-full sm:flex-row sm:items-center"
        onClick={() => setIsOpen(true)}
      >
        <div className="flex flex-col gap-8">
          <Typography
            size="body-lg"
            font="grotesk"
            weight="medium"
            color={Color.Charcoal}
            text={job.title}
          />
        </div>

        <div className="flex shrink-0 items-center gap-32 md:gap-80">
          {job.department && DepartmentIcon && (
            <div className="flex w-fit items-center gap-6 rounded-8 border border-gray px-10 py-6">
              <DepartmentIcon
                className={classNames(
                  "size-20 shrink-0",
                  getTextColorClass(Color.Black)
                )}
              />
              <Typography
                size="body-sm"
                font="grotesk"
                weight="book"
                color={Color.Black}
                text={job.department}
              />
            </div>
          )}
          {job.site && (
            <Typography
              size="body-sm"
              font="grotesk"
              weight="medium"
              color={Color.Black}
              text={job.site}
            />
          )}
          {job.employmentType && (
            <Typography
              size="body-sm"
              font="grotesk"
              weight="medium"
              color={Color.Black}
              text={job.employmentType}
            />
          )}

          <div className="ml-auto rounded-12 p-10 group-hover:bg-light-gray">
            <ChevronIcon className="shrink-0 -rotate-90" />
          </div>
        </div>
      </button>

      <JobDrawer
        job={job}
        drawerData={drawerData}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  )
}

export default JobRow
